// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-button[data-v-e3efedf0]{display:inline-flex;justify-content:center;align-items:center;outline:none;line-height:24px;padding:8px 20px;font-weight:400;font-size:16px;border:none;border-radius:4px;color:#212121;background:#f5f5f5}.app-button[data-v-e3efedf0]:hover{background:#eee}.app-button[data-v-e3efedf0]:active{background:#e0e0e0}", ""]);
// Exports
module.exports = exports;
